<template>
  <div>
    <div :class="s.wrap">
      <div v-if="flag.loading">
        読み込み中です...
      </div>
      <div v-else-if="customer">
        <!-- 顧客名 -->
        <div class="mb-4">
          <p class="fw-bold mb-2">顧客名</p>
          <div :class="s.info_box">
            {{ customer.username || '未登録' }}
          </div>
        </div>

        <!-- 電話番号 -->
        <div class="mb-4">
          <p class="fw-bold mb-2">電話番号</p>
          <div :class="s.info_box">
            <span v-if="customer.tel">{{ formatTel(customer.tel) }}</span>
            <span v-else>未登録</span>
          </div>
        </div>
      </div>
      <div v-else>
        <p class="text-center">顧客情報の取得に失敗しました。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'customer-info',
  props: ['data'],
  data() {
    return {
      flag: {
        loading: false,
      },
      customer: null,
    };
  },
  created() {
    if (this.data.userId) {
      this.getCustomerInfo();
    } else {
      alert('処理中にエラーが発生しました。');
      this.$store.dispatch('modal/contents/hideModal', null, { root: true });
    }
  },
  methods: {
    getCustomerInfo() {
      this.flag.loading = true;
      this.axios({
        method: 'GET',
        url: '/v1/user/get/detail',
        params: {
          id: this.data.userId,
        },
      })
        .then((response) => {
          const res = response.data;
          this.customer = res.detail;
        })
        .catch((error) => {
          console.log(error);
          alert('顧客情報の取得に失敗しました。');
        })
        .finally(() => {
          this.flag.loading = false;
        });
    },
    formatTel(tel) {
      if (!tel) return '';
      // 電話番号を見やすい形式に整形（例: 090-1234-5678）
      const cleaned = tel.replace(/\D/g, '');
      if (cleaned.length === 11) return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
      if (cleaned.length === 10) return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
      return tel;
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  padding: 10px 15px;
  min-height: 200px;
}

.info_box {
  padding: 15px;
  background-color: var(--bg-gray);
  border-radius: 6px;
  font-size: 18px;
  min-height: 50px;
  display: flex;
  align-items: center;
}

.tel_link {
  color: var(--primary-blue);
  text-decoration: none;
  font-weight: bold;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
}
</style>
